import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { DeleteDialogLibraryComponent, DeleteDialogLibraryModule } from 'delete-dialog-library';
import { DeleteDialogConfigurations } from 'dialog-configuration-library';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import { environment } from 'environment-configurations';
import * as i6 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i1$1 from 'ngx-toastr';
import * as i2 from 'file-upload-library';
import * as i3 from 'reference-library';
import * as i4 from 'primeng/dynamicdialog';
import * as i7 from 'custom-radio-button';
import * as i8 from '@angular/router';
import * as i9 from 'app-services-library';
import * as i10 from '@angular/common';
import * as i11 from 'primeng/table';
import * as i12 from 'primeng/api';
import * as i13 from 'primeng/button';
import * as i14 from 'primeng/tooltip';
import * as i15 from 'primeng/dropdown';
import * as i16 from '@angular/forms';
import * as i17 from 'primeng/inputtext';
import * as i18 from 'primeng/fileupload';
import { PrimengLibraryModule } from 'primeng-library';

class VdCustomFileUploadService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.dataFormIdSubject = new BehaviorSubject('');
        this.dataFormId$ = this.dataFormIdSubject.asObservable();
        this.formDataIdChanges = new Subject();
        //private timesheetCheckbocValue = new Subject<any>();
        this.timesheetCheckbocValue = new BehaviorSubject({ checkbox: true });
    }
    sendtimesheetCheckbocValue(value) {
        this.timesheetCheckbocValue.next({ checkbox: value });
    }
    gettimesheetCheckboxValue() {
        return this.timesheetCheckbocValue.asObservable();
    }
    getDocumentTypes() {
        return this.httpClient.get(`/vd/documentTypes`).pipe(map((response) => {
            return response;
        }));
    }
    setListDocumentTypes(value) {
        this._listDocumentTypes = value;
    }
    getListDocumentTypes() {
        return this._listDocumentTypes;
    }
    setDataFormId(dataFormId) {
        this.dataFormIdSubject.next(dataFormId);
    }
    getDataFormId() {
        return this.dataFormId$;
    }
    clearDataFormId() {
        this.dataFormIdSubject.next('');
    }
    syncProfileData(visatype, caseType, caseId, payload) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/documentsSync`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
VdCustomFileUploadService.ɵfac = function VdCustomFileUploadService_Factory(t) { return new (t || VdCustomFileUploadService)(i0.ɵɵinject(i1.HttpClient)); };
VdCustomFileUploadService.ɵprov = i0.ɵɵdefineInjectable({ token: VdCustomFileUploadService, factory: VdCustomFileUploadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCustomFileUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function VdCustomFileUploadComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "button", 11);
    i0.ɵɵlistener("click", function VdCustomFileUploadComponent_div_0_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.syncBeneficiaryProfileData(); });
    i0.ɵɵtext(2, "SYNC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.configurations.disableControls);
} }
function VdCustomFileUploadComponent_div_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "p-dropdown", 17);
    i0.ɵɵlistener("ngModelChange", function VdCustomFileUploadComponent_div_0_div_2_div_1_Template_p_dropdown_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return ctx_r10.configurations.documentTypeDropdownCode = $event; })("ngModelChange", function VdCustomFileUploadComponent_div_0_div_2_div_1_Template_p_dropdown_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(3); return ctx_r12.onDocumentTypeChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r7.configurations.disableControls)("options", ctx_r7.listDocumentTypes)("ngModel", ctx_r7.configurations.documentTypeDropdownCode);
} }
function VdCustomFileUploadComponent_div_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "h6", 19);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 20);
    i0.ɵɵlistener("ngModelChange", function VdCustomFileUploadComponent_div_0_div_2_div_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return ctx_r13.otherName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r8.otherName);
} }
function VdCustomFileUploadComponent_div_0_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "p-fileUpload", 22, 23);
    i0.ɵɵlistener("uploadHandler", function VdCustomFileUploadComponent_div_0_div_2_div_3_Template_p_fileUpload_uploadHandler_1_listener($event) { i0.ɵɵrestoreView(_r17); const _r15 = i0.ɵɵreference(2); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.onUploadHandle($event, _r15); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("accept", ctx_r9.acceptFileType);
    i0.ɵɵproperty("disabled", ctx_r9.configurations.disableControls || ctx_r9.configurations.documentTypeDropdownCode == "")("auto", true);
} }
const _c0 = function (a0) { return { "margin-left": a0 }; };
function VdCustomFileUploadComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, VdCustomFileUploadComponent_div_0_div_2_div_1_Template, 2, 3, "div", 13);
    i0.ɵɵtemplate(2, VdCustomFileUploadComponent_div_0_div_2_div_2_Template, 5, 1, "div", 14);
    i0.ɵɵtemplate(3, VdCustomFileUploadComponent_div_0_div_2_div_3_Template, 3, 3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(5, _c0, (ctx_r2.inputParams == null ? null : ctx_r2.inputParams.coordinateX) + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.configurations.isDocumentTypeRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.configurations.documentTypeDropdownCode === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.configurations.isDocumentUploadRequired);
} }
function VdCustomFileUploadComponent_div_0_ng_template_8_th_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 24);
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2, "Upload Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdCustomFileUploadComponent_div_0_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 24);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 24);
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, VdCustomFileUploadComponent_div_0_ng_template_8_th_7_Template, 3, 0, "th", 25);
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵelementStart(9, "span", 6);
    i0.ɵɵtext(10, "Actions ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r3.inputParams == null ? null : ctx_r3.inputParams.showUploadDate);
} }
function VdCustomFileUploadComponent_div_0_ng_template_9_td_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", file_r19 == null ? null : file_r19.createdOn, " ");
} }
function VdCustomFileUploadComponent_div_0_ng_template_9_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "button", 31);
    i0.ɵɵlistener("click", function VdCustomFileUploadComponent_div_0_ng_template_9_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r27); const file_r19 = i0.ɵɵnextContext().$implicit; const ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.openDoc(file_r19); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !file_r19.fileLocation);
} }
function VdCustomFileUploadComponent_div_0_ng_template_9_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵlistener("click", function VdCustomFileUploadComponent_div_0_ng_template_9_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const file_r19 = i0.ɵɵnextContext().$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.download(file_r19); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdCustomFileUploadComponent_div_0_ng_template_9_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "button", 33);
    i0.ɵɵlistener("click", function VdCustomFileUploadComponent_div_0_ng_template_9_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r34); const file_r19 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.deleteDocumentTypeLis(file_r19); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r23.configurations.disableControls);
} }
function VdCustomFileUploadComponent_div_0_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 24);
    i0.ɵɵelementStart(4, "a", 26);
    i0.ɵɵlistener("click", function VdCustomFileUploadComponent_div_0_ng_template_9_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r36); const file_r19 = ctx.$implicit; const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.openDoc(file_r19); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, VdCustomFileUploadComponent_div_0_ng_template_9_td_6_Template, 2, 1, "td", 25);
    i0.ɵɵelementStart(7, "td", 27);
    i0.ɵɵelementStart(8, "div", 28);
    i0.ɵɵtemplate(9, VdCustomFileUploadComponent_div_0_ng_template_9_div_9_Template, 2, 1, "div", 29);
    i0.ɵɵtemplate(10, VdCustomFileUploadComponent_div_0_ng_template_9_div_10_Template, 2, 0, "div", 29);
    i0.ɵɵtemplate(11, VdCustomFileUploadComponent_div_0_ng_template_9_div_11_Template, 2, 1, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r19 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", file_r19.fileCategory ? file_r19.fileCategory.code === "OTHER" ? file_r19.fileCtaegoryOtherName ? file_r19.fileCategory.name + "-" + file_r19.fileCtaegoryOtherName : file_r19.fileCategory.name : file_r19.fileCategory.name : "-", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", file_r19 == null ? null : file_r19.fileName, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.inputParams == null ? null : ctx_r4.inputParams.showUploadDate);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.configurations.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", file_r19.fileLocation && ctx_r4.configurations.isDownloadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.configurations.isDeleteEnabled);
} }
function VdCustomFileUploadComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, VdCustomFileUploadComponent_div_0_div_1_Template, 3, 1, "div", 2);
    i0.ɵɵtemplate(2, VdCustomFileUploadComponent_div_0_div_2_Template, 4, 7, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "h6", 5);
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6, "List of Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p-table", 7);
    i0.ɵɵtemplate(8, VdCustomFileUploadComponent_div_0_ng_template_8_Template, 11, 1, "ng-template", 8);
    i0.ɵɵtemplate(9, VdCustomFileUploadComponent_div_0_ng_template_9_Template, 12, 6, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.inputParams == null ? null : ctx_r0.inputParams.properties == null ? null : ctx_r0.inputParams.properties.enableSyncButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.configurations.isDocumentTypeRequired || ctx_r0.configurations.isDocumentUploadRequired);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", ctx_r0.uploadedFiles)("scrollable", true);
} }
//import { ComponentLoaderComponent } from 'src/app/modules/visa-designer/component-loader/component-loader-component';
class VdCustomFileUploadComponent {
    constructor(toasterService, uploadService, referenceLibraryService, dialogService, vdCustomFileUploadService, cRef, store, CustomRadioButtonService, route, appServicesLibraryService) {
        this.toasterService = toasterService;
        this.uploadService = uploadService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.vdCustomFileUploadService = vdCustomFileUploadService;
        this.cRef = cRef;
        this.store = store;
        this.CustomRadioButtonService = CustomRadioButtonService;
        this.route = route;
        this.appServicesLibraryService = appServicesLibraryService;
        this.listDocumentReferenceData = [];
        this.showReferenceCodeSection = false;
        this.isFileListModified = new EventEmitter();
        this.getFormId = new EventEmitter();
        // @ViewChild(ComponentLoaderComponent) componentLoader: ComponentLoaderComponent;
        this.observableSubscription$ = new Subject$1();
        //properties = [{'propertyName':'Reference Select','labelName':'Select','styleClass': {'width':'20%','font-size':'20px','color':'red'}},{'propertyName':'Document Type','labelName':'Document Type','styleClass': {'width':'20%','font-size':'10px'}},{'propertyName':'Reference Select','labelName':'Browse & Upload','styleClass': {'width':'30%','font-size':'10px'}}]
        this.displaypopup = false;
        this.selectedField = 0;
        this.documentTypeDropDownCode = '';
        this.displayuploadcomponent = true;
        this.invoiceRadioValue = 'Generate Invoice';
        this.showUploadDate = false;
        this.uploadedFiles = [];
        this.listDocumentTypes = [];
        this.configurations = {
            disableControls: false,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            postApiUrl: '',
            getApiUrl: '',
            deleteApiUrl: '',
            documentTypeDropdownCode: ''
        };
        this.otherName = '';
    }
    ngOnInit() {
        var _a;
        this.userType = sessionStorage.getItem('userTypeRole');
        if (this.fileUploadConfigurations) {
            this.configurations = Object.assign({}, this.fileUploadConfigurations);
            if (this.configurations.isDocumentTypeRequired) {
                this.getDocumentTypeList();
            }
            this.route.queryParams.subscribe(params => {
                const stepParameter = params['step'];
                if (!stepParameter) {
                    this.vdCustomFileUploadService.clearDataFormId();
                }
            });
            if (this.inputParams.name === "generateReceiptFileUpload" || this.inputParams.name === "updateInoviceFileUpload") {
                this.vdCustomFileUploadService.getDataFormId().subscribe(dataFormId => {
                    this.dataFormId = dataFormId;
                    const genFileId = 'genRecieptFileId' in sessionStorage ? parseInt(sessionStorage.getItem('genRecieptFileId')) : null;
                    this.dataFormId = genFileId ? genFileId : this.dataFormId;
                });
            }
            else {
                this.dataFormId = this.configurations.fbFormDataId ? this.configurations.fbFormDataId : '';
            }
            // if (this.configurations.documentTypeDropdownCode) {
            this.getDocuments();
        }
        this.subscription = this.CustomRadioButtonService.getInvoicingRadioChange().subscribe(data => {
            this.invoiceRadioValue = data.radio.name;
            const listDocumentTypes = this.vdCustomFileUploadService.getListDocumentTypes() || [];
            this.displayuploadcomponent =
                this.inputParams.name && (this.inputParams.name !== "signatureDoc" || (this.inputParams.name === "signatureDoc" && this.invoiceRadioValue === 'Generate Invoice'));
            if (this.inputParams.name === "generateReceiptFileUpload" && this.invoiceRadioValue === 'Generate Receipt') {
                this.displayuploadcomponent = false;
                //this.getDocumentTypeList();
            }
            if (this.fileUploadConfigurations && this.configurations.isDocumentTypeRequired) {
                if (this.invoiceRadioValue === "Generate Invoice" && this.inputParams.name === "generateInoviceFileUpload") {
                    this.listDocumentTypes = listDocumentTypes.filter(doc => doc.code === 'OTHERDOCUMENTS');
                }
                else {
                    this.listDocumentTypes = listDocumentTypes;
                }
            }
        });
        if (this.inputParams.name === "updateInoviceFileUpload" || this.inputParams.name === "generateInoviceFileUpload") {
            this.acceptFileType = ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.jpeg,.jpg,.png";
        }
        else if (((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.caseType) === 'I129EFILING') {
            this.acceptFileType = ".pdf,.tiff,.tif,.jpg,.jpeg";
        }
        else {
            this.acceptFileType = ".pdf";
        }
        // console.log("this.fileUploadConfigurations",this.fileUploadConfigurations);
        // try {
        //   console.log("this.configurations",this.configurations);
        // } catch (error) {
        //   console.log("error configurations",this.configurations)
        // }
        if (this.inputParams && this.inputParams.properties && this.inputParams.properties.refercenceCodeForApiCall != '') {
            this.documentTypeDropDownCode = this.inputParams.properties.refercenceCodeForApiCall;
        }
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a, _b, _c;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.configurations.disableControls = (((_b = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _b === void 0 ? void 0 : _b.stepStatusCode) === 'COMPLETE' || ((_c = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _c === void 0 ? void 0 : _c.stepStatusCode) === 'NEW' || ((this.userType === 'Beneficiary' && this.inputData.stepStatusCode === 'SUBMIT'))) ? true : false;
            });
        }
        this.displayuploadcomponent =
            this.inputParams.name && (this.inputParams.name !== "signatureDoc" || (this.inputParams.name === "signatureDoc" && this.invoiceRadioValue === 'Generate Invoice'));
        this.subscription = this.vdCustomFileUploadService.gettimesheetCheckboxValue().subscribe((data) => {
            if (this.inputParams.name == "FILE_UPLOAD_ltodxqrczykbwvcctej") {
                this.displayuploadcomponent = !(data.checkbox);
            }
        });
    }
    getAllDocumentTypes() {
        this.vdCustomFileUploadService.getDocumentTypes()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.listDocumentReferenceData = Object.assign([], response.data);
        });
    }
    onDocumentTypeChange(selectedOption) {
        const selectedDoc = this.listDocumentTypes.find(item => item.code === selectedOption);
        if (selectedDoc) {
            this.refId = selectedDoc.id;
        }
    }
    onUploadHandle(event, fubauto) {
        if (this.configurations.documentTypeDropdownCode === 'OTHER' && this.otherName.trim() === '') {
            CustomErrorToastComponent.showErrorToast(this.toasterService, 'Document Type Name is required');
            fubauto.clear();
            return false;
        }
        const file = event.files[0];
        file.fileName = event.files[0].name;
        const payload = new FormData();
        payload.append('file', file, file.name);
        let apiUrl;
        if (this.configurations.isOutside) {
            let catagoryVal = this.listDocumentTypes.find(item => item.code === this.configurations.documentTypeDropdownCode);
            apiUrl = this.configurations.documentTypeDropdownCode === 'OTHER' ?
                `${this.configurations.postApiUrl}/${catagoryVal['group']}/fileCategory/` + `${this.configurations.documentTypeDropdownCode}` +
                    '?otherName=' + `${this.otherName}` : `${this.configurations.postApiUrl}/${catagoryVal['group']}/fileCategory/${this.configurations.documentTypeDropdownCode}`;
            // FormBuilder
        }
        else if (this.configurations.isFormBuilder) {
            apiUrl = `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode ? 'documentCategory=' + this.configurations.documentTypeDropdownCode : ''}` + `${this.refId ? '&refId=' + this.refId : ''}` + `${this.dataFormId ? '&formDataId=' + this.dataFormId : ''}`;
        }
        else {
            apiUrl = this.configurations.documentTypeDropdownCode === 'OTHER' ?
                `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode}` +
                    '?otherName=' + `${this.otherName}` :
                // this.configurations.documentTypeDropdownCode === 'RECNOTC' ?
                //   `${this.configurations.postApiUrl}` :   // IM-11697 -- issue fix
                `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode}`;
        }
        if (this.configurations.isPetitionerDetailsDocuments) {
            if (this.configurations.documentTypeDropdownCode === 'OTHER') {
                apiUrl = `${apiUrl}&entityId=${this.configurations.petitionerDetailsDocumentsCompanyId}`;
            }
            else {
                apiUrl = `${apiUrl}?entityId=${this.configurations.petitionerDetailsDocumentsCompanyId}`;
            }
        }
        if (this.configurations.familyId) {
            if (this.configurations.isPetitionerDetailsDocuments || this.configurations.documentTypeDropdownCode === 'OTHER') {
                apiUrl = `${apiUrl}&familyId=${this.configurations.familyId}`;
            }
            else {
                apiUrl = `${apiUrl}?familyId=${this.configurations.familyId}`;
            }
        }
        this.uploadService.uploadDocument(apiUrl, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.toasterService.success(response.message, 'Success');
            this.isFileListModified.emit(true);
            // this.componentLoader.loadComponent();
            this.cRef.detectChanges();
            this.otherName = '';
            if (this.configurations.isFormBuilder) {
                this.dataFormId = response.data ? response.data.formDataId : '';
                this.vdCustomFileUploadService.setDataFormId(this.dataFormId);
                this.vdCustomFileUploadService.formDataIdChanges.next({
                    dataFormId: this.dataFormId
                });
            }
            this.getDocuments();
            if (this.configurations.isDocumentTypeRequired) {
                this.configurations.documentTypeDropdownCode = '';
            }
            fubauto.clear();
        });
    }
    getDocuments() {
        if (this.configurations.getApiUrl &&
            (!this.configurations.isFormBuilder || (this.configurations.isFormBuilder && this.dataFormId))) {
            let apiUrl = this.configurations.getApiUrl;
            if (this.configurations.familyId) {
                apiUrl = `${this.configurations.getApiUrl}?familyId=${this.configurations.familyId}`;
            }
            sessionStorage.setItem('getFilesId', this.dataFormId);
            if (this.configurations.isFormBuilder) {
                apiUrl = `${apiUrl}` + `${this.dataFormId}`;
            }
            this.uploadService.getUploadedDocument(apiUrl)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.uploadedFiles = Object.assign([], response.data);
            });
        }
    }
    getDocumentTypeList() {
        this.configurations.documentTypeDropdownCode = '';
        this.referenceLibraryService.getReferenceDocTypeData(this.configurations.getDocTypeApiUrl)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (this.configurations.isOutside) {
                this.listDocumentTypes = response.map(x => {
                    return {
                        code: x.entityType.code,
                        name: x.docName,
                        id: x.entityType.id,
                        desc: x.entityType.description,
                        group: x.entityType.group
                    };
                });
            }
            else {
                this.vdCustomFileUploadService.setListDocumentTypes(response);
                if (this.invoiceRadioValue === "Generate Invoice" && this.inputParams.name === "generateInoviceFileUpload") {
                    this.listDocumentTypes = response.filter(doc => doc.code === 'OTHERDOCUMENTS');
                }
                else {
                    this.listDocumentTypes = response;
                }
            }
        });
    }
    deleteDocumentTypeLis(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.uploadService.deleteUploadDocument(this.configurations.deleteApiUrl + `${input.id}`)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((responseUploadedDocs) => {
                    this.toasterService.success(responseUploadedDocs.message, 'Success');
                    this.isFileListModified.emit(true);
                    this.getDocuments();
                });
            }
        });
    }
    ngOnChanges(e) {
        if (e.fileUploadConfigurations && e.fileUploadConfigurations.currentValue) {
            this.configurations = e.fileUploadConfigurations.currentValue;
            if (this.configurations.isDocumentTypeRequired) {
                this.getDocumentTypeList();
            }
            // if (this.configurations.documentTypeDropdownCode) {
            this.getDocuments();
            // }
        }
    }
    openDoc(item) {
        if (this.configurations.isFormBuilder) {
            const docPath = item.fileLocation;
            window.open(`${environment.appUrl}${docPath}`, '_blank');
        }
        else {
            const docPath = item.fileLocation.substring(23);
            window.open(`${environment.docs}${docPath}`, '_blank');
        }
    }
    download(file) {
        if (this.configurations.isFormBuilder) {
            this.uploadService.downloadDocuments(environment.appUrl + file.fileLocation, file.fileName);
        }
        else {
            this.uploadService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
        }
    }
    handleReferenceCodeChange() {
        // console.log("this.documentReferenceCode",this.documentReferenceCode);
    }
    cancel() {
    }
    saveChange(data) {
        // console.log("data",data)
        // this.customInputData[this.currentIndex] = data;
        this.displaypopup = false;
    }
    syncBeneficiaryProfileData() {
        const payload = {
            "beneficiaryId": this.inputData.beneficiaryId,
            "familyId": this.inputData.familyId,
            "groupCodes": [
                this.documentTypeDropDownCode
            ],
            "primary": true
        };
        this.vdCustomFileUploadService.syncProfileData(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.toasterService.success(response.message, 'Success');
                this.getDocuments();
            }
        });
    }
    // ngAfterViewInit() {
    //   this.translet();
    // }
    // translet() {
    //   setTimeout(() => {
    //     this.referenceLibraryService.transletConversion();
    //   }, 600);
    // }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
VdCustomFileUploadComponent.ɵfac = function VdCustomFileUploadComponent_Factory(t) { return new (t || VdCustomFileUploadComponent)(i0.ɵɵdirectiveInject(i1$1.ToastrService), i0.ɵɵdirectiveInject(i2.FileUploadLibraryService), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService), i0.ɵɵdirectiveInject(i4.DialogService), i0.ɵɵdirectiveInject(VdCustomFileUploadService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i7.CustomRadioButtonService), i0.ɵɵdirectiveInject(i8.ActivatedRoute), i0.ɵɵdirectiveInject(i9.AppServicesLibraryService)); };
VdCustomFileUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdCustomFileUploadComponent, selectors: [["vd-custom-file-upload"]], inputs: { inputParams: "inputParams", inputData: "inputData", fileUploadConfigurations: "fileUploadConfigurations" }, outputs: { isFileListModified: "isFileListModified", getFormId: "getFormId" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "fileUploadContainerWidth", 4, "ngIf"], [1, "fileUploadContainerWidth"], ["class", "syncBtnAlign", 4, "ngIf"], ["class", "row d-flex-align-items-end", 3, "style", 4, "ngIf"], [1, "mb-5", "pt-2", "fileContentSection"], [1, "labelText"], [1, "common-bene-class-for-translation"], ["styleClass", "vdFileUploadTable", "name", "uploadedFiles", "scrollHeight", "120px", 1, "pa-table", 3, "value", "scrollable"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "syncBtnAlign"], ["pButton", "", "type", "button", "pTooltip", "Sync With Profile", "icon", "pi pi-arrow-right-arrow-left", 1, "p-button-rounded", "p-button-text", "syncBtn", "common-bene-class-for-translation-p-button", 3, "disabled", "click"], [1, "row", "d-flex-align-items-end"], ["class", "ml-2 pt-1  processing-dropdown margin-top-3-percentage", 4, "ngIf"], ["class", "col-md-4 p-0 mt-2 px-2", 4, "ngIf"], ["class", "ml-2 pt-1 margin-top-3-percentage", 4, "ngIf"], [1, "ml-2", "pt-1", "processing-dropdown", "margin-top-3-percentage"], ["appendTo", "body", "placeholder", "Select Category", "optionValue", "code", "optionLabel", "name", 3, "disabled", "options", "ngModel", "ngModelChange"], [1, "col-md-4", "p-0", "mt-2", "px-2"], [1, "mb-0"], ["type", "text", "pInputText", "", 3, "ngModel", "ngModelChange"], [1, "ml-2", "pt-1", "margin-top-3-percentage"], ["mode", "basic", "customUpload", "true", "name", "demo[]", "chooseLabel", "Browse & Upload", 1, "common-bene-class-for-translation-p-button", 3, "disabled", "accept", "auto", "uploadHandler"], ["fubauto", ""], ["colspan", "2"], ["colspan", "2", 4, "ngIf"], [2, "cursor", "pointer", 3, "click"], ["nowrap", ""], [1, "d-flex", "flex-row", "documents-icons", "d-flex", "align-items-center"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"]], template: function VdCustomFileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VdCustomFileUploadComponent_div_0_Template, 10, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displayuploadcomponent);
    } }, directives: [i10.NgIf, i11.Table, i12.PrimeTemplate, i13.ButtonDirective, i14.Tooltip, i15.Dropdown, i16.NgControlStatus, i16.NgModel, i16.DefaultValueAccessor, i17.InputText, i18.FileUpload], styles: [".fileUploadContainerWidth[_ngcontent-%COMP%]{width:100%!important}.fileContentSection[_ngcontent-%COMP%]{height:150px!important}.margin-top-3-percentage[_ngcontent-%COMP%]{margin-top:2%}.labelTex[_ngcontent-%COMP%]{font-weight:600}.syncBtn[_ngcontent-%COMP%]{width:100px!important;font-size:14px!important;font-weight:700!important;background:none!important}.syncBtnAlign[_ngcontent-%COMP%]{float:right}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCustomFileUploadComponent, [{
        type: Component,
        args: [{
                selector: 'vd-custom-file-upload',
                templateUrl: 'vd-custom-file-upload.component.html',
                styleUrls: ['vd-custom-file-upload.component.scss']
            }]
    }], function () { return [{ type: i1$1.ToastrService }, { type: i2.FileUploadLibraryService }, { type: i3.ReferenceLibraryService }, { type: i4.DialogService }, { type: VdCustomFileUploadService }, { type: i0.ChangeDetectorRef }, { type: i6.Store }, { type: i7.CustomRadioButtonService }, { type: i8.ActivatedRoute }, { type: i9.AppServicesLibraryService }]; }, { inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], fileUploadConfigurations: [{
            type: Input
        }], isFileListModified: [{
            type: Output
        }], getFormId: [{
            type: Output
        }] }); })();

class VdCustomFileUploadModule {
}
VdCustomFileUploadModule.ɵfac = function VdCustomFileUploadModule_Factory(t) { return new (t || VdCustomFileUploadModule)(); };
VdCustomFileUploadModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdCustomFileUploadModule });
VdCustomFileUploadModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            DeleteDialogLibraryModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdCustomFileUploadModule, { declarations: [VdCustomFileUploadComponent], imports: [DeleteDialogLibraryModule,
        PrimengLibraryModule], exports: [VdCustomFileUploadComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCustomFileUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [VdCustomFileUploadComponent],
                imports: [
                    DeleteDialogLibraryModule,
                    PrimengLibraryModule
                ],
                exports: [VdCustomFileUploadComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-custom-file-upload
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdCustomFileUploadComponent, VdCustomFileUploadModule, VdCustomFileUploadService };
//# sourceMappingURL=vd-custom-file-upload.js.map
